// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2hgh_","footer":"ModalUpdate_footer__3ZVro"};